import { exportsModule } from '@cian/mf-registry/browser';

import { createCustomElementConstructor } from './createCustomElementConstructor';
import { createContext } from '../services/runApp/createContext';
import { createApplicationState } from '../services/applicationState';

export function start() {
  const context = createContext();
  const store = createApplicationState(context);

  exportsModule({
    ui: {
      '/public/v1/get-my-home-microfrontend/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
  });
}
